import React, { useCallback, useContext } from 'react';
import { Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { resetForm, saveSchedule, deleteSchedule } from '@store/policies/schedule/actions';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { formModes } from '@store/policies/schedule/formReducer';
import Content from './Content';
import { StyledModal } from './styled';
import { trackModalActions } from './track';
import { actOptions, policyAction } from '@store/policies/schedule/utils';
import EventContext from '@src/pages/Precision/PrecisionPolicy/EventContext';
import PopupView from '../Policies/PopupView';
import { Validator } from './Validator';
import useFetchSchedules from '@src/pages/Precision/hooks/useFetchSchedules';

const modeButtonMap = {
  [formModes.new]: {
    type: 'primary',
    text: 'Save',
    key: 'new',
  },
  [formModes.edit]: {
    type: 'primary',
    text: 'Update',
    key: 'edit',
  },
  [formModes.delete]: {
    type: 'danger',
    text: 'Delete',
    key: 'delete',
  },
};

function ReorderScheduleModal() {
  const dispatch = useDispatch();
  const { forceUpdateSchedulesData } = useFetchSchedules(policyAction.reorder);
  const { mode, activationState, loading, triggerAt, visible, modalType, order } =
    useSelector(formViewSelector);

  const { reorderPolicies } = useContext(EventContext);

  const onCancel = useCallback(() => {
    dispatch(resetForm());
  }, [dispatch]);

  const onSubmit = useCallback(() => {
    if (activationState === actOptions.now) {
      reorderPolicies(order);
      onCancel();
      return;
    }

    trackModalActions(mode, activationState);
    if (mode === formModes.delete) {
      dispatch(deleteSchedule(onCancel));
    } else {
      if (moment(triggerAt).isBefore(moment())) {
        message.error('Date can not be in the past.');
        return;
      }
      dispatch(saveSchedule(onCancel, policyAction.reorder));
    }
    forceUpdateSchedulesData();
  }, [
    onCancel,
    triggerAt,
    mode,
    activationState,
    order,
    reorderPolicies,
    dispatch,
    forceUpdateSchedulesData,
  ]);

  const { type, text, key } = modeButtonMap[mode];

  return (
    <>
      <StyledModal
        styles={{ body: { overflowY: 'auto', maxHeight: '400px' } }}
        open={modalType === policyAction.reorder && visible}
        title={
          <>
            <div>{`Reorder Policy (${mode[0].toUpperCase() + mode.slice(1)})`}</div>{' '}
            <div>Changes compared to existing order</div>{' '}
          </>
        }
        onOk={onSubmit}
        onCancel={onCancel}
        footer={[
          <Content key="content" type={policyAction.reorder} />,
          <Button key="Cancel" onClick={onCancel}>
            Cancel
          </Button>,
          <Validator key={key} deleteMode={mode === formModes.delete}>
            {(canSubmit, key) => (
              <Button
                type={type}
                key={key}
                loading={loading}
                onClick={onSubmit}
                disabled={!canSubmit}
              >
                {text}
              </Button>
            )}
          </Validator>,
        ]}
      >
        <div>
          <PopupView order={order} />
        </div>
      </StyledModal>
    </>
  );
}

export default ReorderScheduleModal;
